import { Component, inject, OnInit } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { SimpleNotificationsModule } from 'angular2-notifications'
import type { KeycloakProfile } from 'keycloak-js'
import { DialogModule } from 'primeng/dialog'
import { catchError, filter, from, of } from 'rxjs'
import packageInfo from '../../package.json'
import { AuthenticationService } from './shared/services/authentication.service'
import { ConfigService } from './shared/services/config.service'
import { LogService } from './shared/services/log.service'
import { setUser } from './shared/store/stage/stage.actions'

@Component({
   selector: 'matchpoint-root',
   standalone: true,
   imports: [RouterOutlet, SimpleNotificationsModule, DialogModule],
   templateUrl: './app.component.html',
   styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
   private _cn = this.constructor.name
   private _store = inject(Store)
   protected configService = inject(ConfigService)
   private _authService = inject(AuthenticationService)

   constructor(private _logService: LogService) {
      this._logService.packageName = packageInfo.name
      this._logService.packageVersion = packageInfo.version
      this._logService.enableLog = this.configService.environment != 'prod'
   }

   ngOnInit(): void {
      this.setUser()
   }

   private setUser() {
      const mn = this.setUser.name
      from(this._authService.keycloakAngular.loadUserProfile())
         .pipe(
            filter((res) => res != null && res != undefined),
            catchError((error) => {
               this._logService.error(this._cn, mn, 'Cannot retrive user info... logout')
               this._authService.keycloakAngular.logout()
               return of(error)
            })
         )
         .subscribe((user: KeycloakProfile) => {
            this._store.dispatch(setUser({ user: `${user.firstName} ${user.lastName}` }))
         })
   }
}
